








import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Contacts'
})
export default class Bio extends Vue {
  delays: number[]
  texts: string[]

  constructor () {
    super()
    this.texts = [
      'Ludovic Petrenko',
      'ludovic.petrenko@outlook.com',
    ]
    this.delays = [200, 200, 200, 300]
  }

  visibilityChanged (isVisible: boolean, entry: any) {
    if (isVisible) {
      let sum = 800
      for (let i in this.delays) {
        sum += this.delays[i]
        setTimeout(() => {
          Vue.set(this.delays, i, 0)
        }, sum)
      }
    } else if (entry.boundingClientRect.top >= 0) {
      Vue.set(this, 'delays', [200, 300, 300, 300])
    }
  }
}
